/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import FractionDisplay from '../ui/FractionDisplay';

export default class CompareNumbersDisplay extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.transitionCounter = 0;

    this.bg1 = ABCyaPhaser.Images.addImage(0, 0, 'AnswerBg', this).setOrigin(0, 0);
    this.bg2 = ABCyaPhaser.Images.addImage(0, 0, 'AnswerBg', this).setOrigin(0, 0);
    this.bg2.x = 597;

    this.answer1 = this.scene.add.bitmapText(0, 0, 'asapBoldLarge', '1.31', 120).setVisible(false)
      .setTintFill('0xd3681b');
    this.add(this.answer1);
    this.answer2 = this.scene.add.bitmapText(0, 0, 'asapBoldLarge', '22', 120).setVisible(false)
      .setTintFill('0xd3681b');
    this.add(this.answer2);

    this.fraction1 = new FractionDisplay(this.scene, this).setVisible(false);
    this.fraction2 = new FractionDisplay(this.scene, this).setVisible(false);
  }

  displayNumbers(num1, num2) {
    this.value1 = num1;
    this.value2 = num2;
    if (num1.type === gameData.GAMETYPE_WHOLE_NUMBERS || num1.type === gameData.GAMETYPE_DECIMALS) {
      this.answer1.text = num1.value.toString();
      this.answer1.setVisible(true);

      this.answer1.x = this.bg1.x + (this.bg1.getBounds().width / 2 - this.answer1.width / 2);
      this.answer1.y = this.bg1.y + (this.bg1.getBounds().height / 2 - this.answer1.height / 2);
      this.fraction1.setVisible(false);
    }
    else {
      this.fraction1.updateDisplay(num1.value);
      this.fraction1.setVisible(true);
      this.fraction1.x = this.bg1.x + (this.bg1.getBounds().width / 2 - this.fraction1.getBounds().width / 2);

      this.answer1.setVisible(false);
    }
    if (num2.type === gameData.GAMETYPE_WHOLE_NUMBERS || num2.type === gameData.GAMETYPE_DECIMALS) {
      this.answer2.text = num2.value.toString();
      this.answer2.setVisible(true);

      this.answer2.x = this.bg2.x + (this.bg2.getBounds().width / 2 - this.answer2.width / 2);
      this.answer2.y = this.bg2.y + (this.bg2.getBounds().height / 2 - this.answer2.height / 2);
      this.fraction2.setVisible(false);
    }
    else {
      this.fraction2.updateDisplay(num2.value);
      this.fraction2.setVisible(true);
      this.fraction2.x = this.bg2.x + (this.bg2.getBounds().width / 2 - this.fraction2.getBounds().width / 2);

      this.answer2.setVisible(false);
    }
    this.transitionCounter = 23;
    this.numberTransition();
    const n = Phaser.Math.Between(1, 100);
    n > 50 ? ABCyaPhaser.Audio.playOneShot('tire_skid', this.scene) : ABCyaPhaser.Audio.playOneShot('race_car_drive_by', this.scene);
  };

  numberTransition() {
    if (this.transitionCounter <= 0) {
      // Set to the actual answer
      if (this.value1.type === gameData.GAMETYPE_WHOLE_NUMBERS || this.value1.type === gameData.GAMETYPE_DECIMALS) {
        this.answer1.text = this.value1.value.toString();
        this.answer1.setVisible(true);

        this.answer1.x = this.bg1.x + (this.bg1.getBounds().width / 2 - this.answer1.width / 2);
        this.answer1.y = this.bg1.y + (this.bg1.getBounds().height / 2 - this.answer1.height / 2);
      }
      else {
        this.fraction1.updateDisplay(this.value1.value);
        this.fraction1.setVisible(true);

        this.fraction1.x = this.bg1.x + (this.bg1.getBounds().width / 2 - this.fraction1.getBounds().width / 2);
      }
      if (this.value2.type === gameData.GAMETYPE_WHOLE_NUMBERS || this.value2.type === gameData.GAMETYPE_DECIMALS) {
        this.answer2.text = this.value2.value.toString();
        this.answer2.setVisible(true);

        this.answer2.x = this.bg2.x + (this.bg2.getBounds().width / 2 - this.answer2.width / 2);
        this.answer2.y = this.bg2.y + (this.bg2.getBounds().height / 2 - this.answer2.height / 2);
        this.fraction2.setVisible(false);
      }
      else {
        this.fraction2.updateDisplay(this.value2.value);
        this.fraction2.setVisible(true);
        this.fraction2.x = this.bg2.x + (this.bg2.getBounds().width / 2 - this.fraction2.getBounds().width / 2);
      }
      this.emit('QUESTION_READY');
    }
    else {
      // Make up a random one
      if (this.value1.type === gameData.GAMETYPE_WHOLE_NUMBERS) {
        const num = Phaser.Math.Between(1, 100);
        this.answer1.text = num.toString();
        this.answer1.setVisible(true);

        this.answer1.x = this.bg1.x + (this.bg1.getBounds().width / 2 - this.answer1.width / 2);
        this.answer1.y = this.bg1.y + (this.bg1.getBounds().height / 2 - this.answer1.height / 2);
      }
      else if (this.value1.type === gameData.GAMETYPE_DECIMALS) {
        const num = Phaser.Math.Between(1, 100) / 10;
        this.answer1.text = num.toString();
        this.answer1.setVisible(true);

        this.answer1.x = this.bg1.x + (this.bg1.getBounds().width / 2 - this.answer1.width / 2);
        this.answer1.y = this.bg1.y + (this.bg1.getBounds().height / 2 - this.answer1.height / 2);
      }
      else {// fractions
        this.fraction1.showRandomFraction();
      }

      if (this.value2.type === gameData.GAMETYPE_WHOLE_NUMBERS) {
        const num = Phaser.Math.Between(1, 100);
        this.answer2.text = num.toString();
        this.answer2.setVisible(true);

        this.answer2.x = this.bg2.x + (this.bg2.getBounds().width / 2 - this.answer2.width / 2);
        this.answer2.y = this.bg2.y + (this.bg2.getBounds().height / 2 - this.answer2.height / 2);
      }
      else if (this.value2.type === gameData.GAMETYPE_DECIMALS) {
        const num = Phaser.Math.Between(1, 100) / 10;
        this.answer2.text = num.toString();
        this.answer2.setVisible(true);

        this.answer2.x = this.bg2.x + (this.bg2.getBounds().width / 2 - this.answer2.width / 2);
        this.answer2.y = this.bg2.y + (this.bg2.getBounds().height / 2 - this.answer2.height / 2);
      }
      else {// fractions
        this.fraction2.showRandomFraction();
      }
      this.transitionCounter--;
      this.scene.time.delayedCall(40, () => { this.numberTransition(); });
    }
  };

  layoutRatio() {
    this.bg2.x = 597;
    this.answer1.x = this.bg1.x + (this.bg1.getBounds().width / 2 - this.answer1.width / 2);
    this.answer1.y = this.bg1.y + (this.bg1.getBounds().height / 2 - this.answer1.height / 2);
    this.answer2.x = this.bg2.x + (this.bg2.getBounds().width / 2 - this.answer2.width / 2);
    this.answer2.y = this.bg2.y + (this.bg2.getBounds().height / 2 - this.answer2.height / 2);
    this.fraction1.x = this.bg1.x + (this.bg1.getBounds().width / 2 - this.fraction1.getBounds().width / 2);
    this.fraction1.y = 70;
    this.fraction2.x = this.bg2.x + (this.bg2.getBounds().width / 2 - this.fraction2.getBounds().width / 2);
    this.fraction2.y = 70;
  };
}